// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style__breadcrumb__CXxEn","list":"style__list__0kYgI"};